import { render, staticRenderFns } from "./GOLD.vue?vue&type=template&id=677538d2&scoped=true"
import script from "./GOLD.vue?vue&type=script&lang=js"
export * from "./GOLD.vue?vue&type=script&lang=js"
import style0 from "./GOLD.vue?vue&type=style&index=0&id=677538d2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "677538d2",
  null
  
)

export default component.exports